module.exports = __webpack_public_path__ + "img/android_en.fd327c32.png";